<section class="section breadcrumb-area bg-overlay d-flex align-items-center">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <!-- Breamcrumb Content -->
                <div class="breadcrumb-content d-flex flex-column align-items-center text-center">
                    <h3 class="text-white" style="text-shadow: 1px 1px 12px #fff;">PT. SURYA MANDIRI MUTUTAMA - Helmet and Corporate Essentials Manufacture</h3>
                    <ol class="breadcrumb justify-content-center">
                        <li class="breadcrumb-item"></li>
                    </ol>
                </div>
            </div>
        </div>
    </div>
</section>